import React from 'react';
import PropTypes from 'prop-types';
import Button, { LinkButton } from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';
import Footer from './Footer';
const DefaultFooter = _ref => {
  let {
    today,
    reset,
    renderFooterActions
  } = _ref;
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("../i18n/".concat(locale, ".json"));
  });
  return /*#__PURE__*/React.createElement(Footer, null, renderFooterActions === null || renderFooterActions === void 0 ? void 0 : renderFooterActions({
    today
  }), reset && /*#__PURE__*/React.createElement(LinkButton, {
    onClick: reset,
    size: Button.SIZES.SMALL,
    style: {
      marginTop: theme.spacing.XXS
    }
  }, T.translate('RESET')));
};
DefaultFooter.displayName = 'DefaultFooter';
DefaultFooter.propTypes = {
  today: PropTypes.func.isRequired,
  renderFooterActions: PropTypes.func,
  reset: PropTypes.func
};
export default DefaultFooter;
//# sourceMappingURL=DefaultFooter.js.map